import React from "react";
import CustomImg from "./common/CustomImg";
import { Card } from "reactstrap";
// import "./OfferCard.scss";
import { Link } from "react-router-dom";
import routes from "../constants/routes";
import { Loader } from "../utils/common";
import "./OfferCard.scss";
import { distance, appropriateDistance } from "../helpers/mapHelpers";
import { usePosition } from "./common/getLocation";
import { dealType } from "../constants/serverConstants";

const cardTypeSubMerchant = "sub-merchant";

function OfferCard(props) {
  const { postItem, cardType } = props; //position
  // id, artwork, dealDiscount, title
  const { position } = usePosition();

  /*
  id: "d8c36e47-7753-4949-a814-a9e7a0789189"
  title: "UIT ASlkdjaklsdj"
  artwork: "https://dev-cdn-offer.fonepay.com/offercontent/offer/9432e83821f44e09acef1cd86bf81297"
  dealType: 1
  dealDiscount: 100
  subMerchants: [{id: "55812b8f-0c59-46c3-af73-380ffc078284", categoryId: "112bcad2-8b41-4b6a-ae1c-71a697fef15f",…}]
  weight: 1
  */
  const cardRoutes =
    cardType === cardTypeSubMerchant
      ? routes["merchants"]
      : routes["offerDetails"];

  if (!postItem) return <Loader />;
  // console.log("id", postItem);

  return (
    <div className="offercard mb-4-">
      <Card className="clearfix">
        <Link to={`${cardRoutes}/${postItem.id}`}>
          <CustomImg url={postItem.artwork} />

          {postItem.dealDiscount > 0 && (
            <div className="discount">
              {postItem.dealType === dealType.FLAT ? (
                <span style={{ marginRight: 3 }}>Rs </span>
              ) : (
                ""
              )}
              <span className="number">{postItem.dealDiscount}</span>
              <span className="type">
                {postItem.dealType === dealType.PERCENTAGE ? "%" : ""}
              </span>
            </div>
          )}

          <div className="offercard-details">
            <h3 className="offer" title={postItem.title}>
              {/* {postItem.dealDiscount}% cashback */}
              <span
                className="line-clamp-2"
                id={`UncontrolledTooltip-${postItem.id}`}
              >
                {postItem.title}
              </span>
              {/* <TextTruncate
                line={2}
                element="span"
                truncateText=""
                text={postItem.title}
                textTruncateChild=""
              /> */}
            </h3>

            {/* contains distance, outlets for offer list page */}
            {postItem.subMerchants && (
              <>
                {postItem.subMerchants[0] && (
                  <>
                    <div className="sub-merchant">
                      {/* {postItem.title} */}
                      <span className="line-clamp-1">
                        {postItem.subMerchants[0].name}
                      </span>

                      {/* <TextTruncate
                        line={1}
                        element="span"
                        truncateText=""
                        text={postItem.subMerchants[0].name}
                        textTruncateChild=""
                      /> */}
                    </div>

                    {position && (
                      <div className="distance">
                        <span>
                          {/* {parseInt(postItem.subMerchants[0].distance)}m away */}
                          {appropriateDistance(
                            distance(
                              position.coords.latitude,
                              position.coords.longitude,
                              postItem.subMerchants[0].latitude, // postItem.latitude for Merchants list page
                              postItem.subMerchants[0].longitude
                            )
                          )}
                        </span>
                      </div>
                    )}

                    {postItem.subMerchants.length > 1 && (
                      <small className="outlets">
                        {postItem.subMerchants.length} outlets
                      </small>
                    )}
                  </>
                )}
              </>
            )}

            {/* contains distance for sub merchants */}
            {cardType === cardTypeSubMerchant && (
              <>
                {position && (
                  <div className="distance">
                    <span>
                      {/* {parseInt(postItem.subMerchants[0].distance)}m away */}
                      {distance(
                        position.coords.latitude,
                        position.coords.longitude,
                        postItem.latitude,
                        postItem.longitude
                      ).toFixed(2)}
                      km away
                    </span>
                  </div>
                )}

                {postItem.offerCount > 1 && (
                  <small className="outlets">
                    {postItem.offerCount} offers
                  </small>
                )}
              </>
            )}
          </div>
        </Link>
      </Card>
    </div>
  );
}

export default OfferCard;
